import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/content';
import { formatDate, formatViews } from '@/utils/content';

export default function NewsListItem({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-100 border border-background-200 hover:border-primary-500/60 transition-colors cursor-pointer"
    >
      <div className="w-full sm:w-56 h-40 sm:h-36 rounded-md overflow-hidden shrink-0">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - ${item.categoryName}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="min-w-0 flex-1 flex flex-col">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="px-2 py-0.5 rounded-md bg-primary-500/15 border border-primary-500/40 text-primary-300 text-xs font-medium">
            {item.categoryName}
          </span>
          {item.hot && (
            <span className="px-2 py-0.5 rounded-md bg-accent-500/15 border border-accent-500/40 text-accent-400 text-xs font-medium flex items-center gap-1">
              <i className="ri-fire-fill" />热门
            </span>
          )}
        </div>
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mt-2.5 line-clamp-2 group-hover:text-primary-400 transition-colors leading-snug">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">{item.summary}</p>
        <div className="mt-auto pt-3 flex items-center flex-wrap gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line" />
            {item.source}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {formatDate(item.date)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {formatViews(item.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}